import { render, staticRenderFns } from "./RewardLayout.vue?vue&type=template&id=add0d834&"
import script from "./RewardLayout.vue?vue&type=script&lang=js&"
export * from "./RewardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports